(() => {
  if (window.tradCateringCheckoutReady) return;
  window.tradCateringCheckoutReady = true;
  const root = window.Shopify?.routes?.root || '/';
  let checking = false;
  async function check(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
      const cart = await response.json();
      const catering = cart.items.filter(item => String(item.product_id) === '15441487429884');
      if (catering.length) {
        if (catering.reduce((total,item)=>total+item.final_line_price,0)<50000) throw new Error('Catering requires a $500 broth subtotal before delivery and tax. Please add more broth before checking out.');
        if (cart.items.some(item => item.requires_shipping && String(item.product_id) !== '15441487429884')) {
          throw new Error('Please order catering separately from frozen packs. Remove the other products from your cart before checking out.');
        }
        const dates = new Set(catering.map(item => item.properties?._delivery_at));
        if (dates.size !== 1 || catering.some(item => {
          const p = item.properties || {};
          return !p['Delivery date'] || !p['Delivery time'] || !p.Preparation || !p._delivery_at || !Number.isFinite(Date.parse(p._delivery_at)) || Date.parse(p._delivery_at) - Date.now() < 86400000;
        })) {
          throw new Error('Catering requires one delivery time at least 24 hours ahead. Remove the catering items, then return to the catering page to choose a new date and time.');
        }
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      let message = document.getElementById('trad-catering-cart-error');
      if (!message) {
        message = document.createElement('p');
        message.id = 'trad-catering-cart-error';
        message.setAttribute('role', 'alert');
        message.setAttribute('tabindex', '-1');
        const target = document.getElementById('cart-errors') || document.querySelector('.cart__ctas, .cart-drawer__footer') || document.body;
        target.append(message);
      }
      message.textContent = error.message;
      message.focus();
    } finally {
      checking = false;
    }
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
    if (!control) return;
    const href = control.getAttribute('href');
    if (control.name === 'checkout' || (href && new URL(href, location.href).pathname.replace(/\/$/, '').endsWith('/checkout'))) check(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') check(event);
  }, true);
})();
